import { render, staticRenderFns } from "./RoleRemoved.vue?vue&type=template&id=73c8f93f&scoped=true"
import script from "./RoleRemoved.vue?vue&type=script&lang=js"
export * from "./RoleRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8f93f",
  null
  
)

export default component.exports